var _path, _g, _path2, _path3, _rect, _rect2, _path4, _g2, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNoResults = function SvgIconNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 124 121"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_NoResults_svg__a)",
    d: "M69.483 106.609a6.37 6.37 0 0 1 .225-9.22l9.096-8.252a15.4 15.4 0 0 1 4.198-2.715l8.934-3.898A5.625 5.625 0 1 1 96.01 93l-2.909.997a8.4 8.4 0 0 0-3.017 1.81L78.33 106.764a6.37 6.37 0 0 1-8.847-.155"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Icon_NoResults_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C499",
    fillOpacity: 0.5,
    d: "M70.533 29.197c-11.415-11.414-29.921-11.414-41.336 0s-11.414 29.922 0 41.336c11.415 11.415 29.921 11.415 41.336 0l7.844 7.844c-15.747 15.746-41.277 15.746-57.024 0s-15.746-41.277 0-57.023 41.277-15.747 57.024 0 15.746 41.276 0 57.023l-7.844-7.844c11.415-11.414 11.415-29.921 0-41.336"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_NoResults_svg__c)",
    stroke: "url(#Icon_NoResults_svg__d)",
    strokeWidth: 0.809,
    d: "M21.64 21.64c15.588-15.589 40.862-15.589 56.45 0 15.493 15.493 15.586 40.55.283 56.16L71.1 70.53c11.288-11.594 11.195-30.14-.282-41.618-11.573-11.572-30.336-11.573-41.908 0s-11.573 30.336 0 41.909c11.477 11.477 30.024 11.569 41.618.281l7.271 7.272c-15.61 15.303-40.668 15.21-56.16-.282-15.59-15.589-15.59-40.863 0-56.451Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_NoResults_svg__e)",
    stroke: "url(#Icon_NoResults_svg__f)",
    strokeWidth: 0.809,
    d: "M89.615 82.565c.6-.733 1.693-.802 2.346-.149l24.994 24.993a6.917 6.917 0 0 1-9.781 9.782L82.18 92.197c-.653-.652-.584-1.746.148-2.345a52 52 0 0 0 7.287-7.288Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.045,
    height: 12.836,
    x: 79.705,
    y: 101.895,
    fill: "url(#Icon_NoResults_svg__g)",
    rx: 6.418,
    transform: "rotate(-45 79.705 101.895)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16.045,
    height: 12.836,
    x: 89.35,
    y: 111.539,
    fill: "url(#Icon_NoResults_svg__h)",
    rx: 6.418,
    transform: "rotate(-45 89.35 111.539)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_NoResults_svg__i)",
    d: "M123.487 99.12c.401 6.419-.525 9.455-4.097 13.028-.596-4.467-3.926-6.609-4.728-7.412-7.621-3.209-12.435-12.435-12.435-12.435s-3.552-3.65-6.36-8.142c-1.511-2.418-3.271-6.613-4.575-9.972-1.085-2.798.483-5.878 3.354-6.751 2.332-.71 4.846.263 6.132 2.334 2.825 4.549 7.671 12.055 9.873 13.706 3.209 2.407 12.345 7.79 12.836 15.644"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Icon_NoResults_svg__j)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.161,
    cy: 49.613,
    r: 24.261,
    stroke: "url(#Icon_NoResults_svg__k)",
    strokeWidth: 1.591
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.161,
    cy: 49.613,
    r: 23.437,
    fill: "url(#Icon_NoResults_svg__l)",
    stroke: "url(#Icon_NoResults_svg__m)",
    strokeWidth: 3.237
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_svg__a",
    x1: 70.629,
    x2: 85.728,
    y1: 105.299,
    y2: 90.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14111C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_svg__c",
    x1: 50.011,
    x2: 50.011,
    y1: 9.126,
    y2: 93.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#00C499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_svg__d",
    x1: 50.011,
    x2: 50.011,
    y1: -7.251,
    y2: 76.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#00C499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#00C499",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_svg__e",
    x1: 80.382,
    x2: 107.478,
    y1: 84.159,
    y2: 111.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_svg__f",
    x1: 96.163,
    x2: 99.853,
    y1: 80.288,
    y2: 119.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#00C499",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_svg__i",
    x1: 88.588,
    x2: 119.29,
    y1: 61.012,
    y2: 132.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#14111C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_svg__k",
    x1: 34.501,
    x2: 25.105,
    y1: 49.613,
    y2: 74.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C499",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_NoResults_svg__m",
    x1: 35.053,
    x2: 25.105,
    y1: 49.613,
    y2: 68.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C499",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C499"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Icon_NoResults_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-16.0454 0 0 -40.5784 95.75 108.313)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14111C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Icon_NoResults_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-16.0454 0 0 -40.5784 105.395 117.957)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14111C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Icon_NoResults_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-45 102.686 7.03)scale(70.8696)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#00C499",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C499",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Icon_NoResults_svg__b",
    width: 99.73,
    height: 99.731,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_9815_27912",
    stdDeviation: 4.772
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Icon_NoResults_svg__j",
    width: 58.065,
    height: 58.066,
    x: 21.128,
    y: 20.58,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_9815_27912",
    stdDeviation: 1.988
  })))));
};
export default SvgIconNoResults;